









































































































































































/*
  getParam 获取命题教师评价页面参数
  getPropositionTchEvaluate 获取命题教师评价分页列表
*/
import { Vue, Component } from "vue-property-decorator";
//引入接口调用函数
import {
  getParam,
  getPropositionTchEvaluate,
  deleteInfo
} from "../../../api/propositionTeacherEvaluate";
import importAndExportMixin from "../../../mixins/importAndExport";

@Component({
  name: "propositionTeacherEvaluate",
  mixins: [importAndExportMixin],
  components: {
    UploadProgress: () => import("@/components/UploadProgress/index.vue"),
  },
})
export default class extends Vue {
  private projectId: string = ""; //项目id
  private subjectId: string = ""; //科目
  private evaluateStatus: number | null = null; //评价状态 0:未评 1:已评
  private isRecommend: number | null = null; //是否重点推荐 0:是 1:否
  private isBlacklist: number | null = null; //是否黑名单 0:否,1:是
  private school: string = ""; //单位
  private teacherName: string = ""; //教师
  private showTableLoading: boolean = false; //是否显示列表loading
  private tableData: object[] = []; //列表数据
  private pageNo: number = 1; //当前页码
  private pageSize: number = 10; //当前条目
  private total: number = 0; //总条数
  private chooseArray: object[] = []; //勾选的数据集合
  private orderObj: any = { orderBy: "", order: "" }; //当前排序的对象 { 排序字段, 升序/降序 }
  //页面参数
  private projects: object[] = []; //项目数组
  private subjects: object[] = []; //科目数组
  private tableHeight: number = 0;
  public $refs!: {
    table: HTMLFormElement;
  };
  private uploadData = {progressId: -1, projectId: this.projectId}; // 文件上传入参

  created() {
    //获取页面参数
    this.getParams();
    //获取列表
    this.getData();
  }

  mounted() {
    setTimeout(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 80;
      if (this.tableHeight < 300) { this.tableHeight = 300; }
    }, 100);
  }

  //上传地址
  get uploadUrl() {
    return window.config.baseUrl4Shool + "/propositionteacher/propositionTchEvaluate/upload";
  }

  // 根据分页计算页码
  private indexMethod(index) {
    return index + 1 + (this.pageNo - 1) * this.pageSize;
  }

  //获取页面参数
  private async getParams() {
    try {
      let res = await getParam();
      this.projects = res.data.projects;
      this.subjects = res.data.subjects;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //列表接口和导出接口的传参
  private getRequestParams() {
    let params = {
      current: this.pageNo, //当前页
      size: this.pageSize, //记录数
      evaluateState: this.evaluateStatus, //评价状态 0:未评 1:已评
      otherinfoIsBlacklist: this.isBlacklist, //是否黑名单 0:否,1:是
      otherinfoIsRecommend: this.isRecommend, //是否重点推荐 0:是 1:否
      projectId: this.projectId, //项目id
      subjectId: this.subjectId, // 科目id
      schoolName: this.school, //所属学校/单位名称
      teacherName: this.teacherName //教师姓名
    };
    if (this.orderObj.orderBy) {
      //排序字段
      params[this.orderObj.orderBy] = this.orderObj.order;
    }
    return params;
  }

  //获取列表数据
  private async getData() {
    this.showTableLoading = true;
    try {
      let res = await getPropositionTchEvaluate(this.getRequestParams());
      this.showTableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      this.showTableLoading = false;
      // this.$message.error(error || "获取数据失败");
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  //搜索查询
  private searchHandle() {
    this.pageNo = 1;
    this.getData();
  }

  //勾选处理
  private selectChangeHandle(v: object[]) {
    this.chooseArray = v.map((item) => {
      return {
        projectId:  item['projectId'], // 项目id
        subjectId: item[`subjectId`], //科目id
        teacherId:  item[`teacherId`] // 教师id
      };
    });
  }

  //排序处理
  private sortChange(v: { column: object; prop: string; order: string }) {
    let { column, prop, order } = v;
    //判断排序字段，获取列表数据
    switch (prop) {
      //评价星级
      case "evaluateStar":
        this.orderObj = { orderBy: "orderByEvaluateStar", order: order };
        this.getData();
        break;
      //命题次数
      case "teacherNum":
        this.orderObj = { orderBy: "orderByTeacherNum", order: order };
        this.getData();
        break;
      //优秀教师
      case "otherinfoIsExcellentTeacherValue":
        this.orderObj = { orderBy: "orderByIsExcellentTeacher", order: order };
        this.getData();
        break;
    }
  }

  //删除处理
  private deleteHandle() {
    if (this.chooseArray.length <= 0) {
      this.$message.warning("请勾选教师！");
      return false;
    }
    //询问是否删除
    this.$confirm("确定删除评价?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      try {
        await deleteInfo(this.chooseArray);
        this.$message.success("删除评价成功");
        //操作成功，重新获取列表
        this.getData();
      } catch (error) {
        this.$message.error(error.mesg || error || "删除评价失败");
      }
    });
  } 

  // 每页条目变化时
  private handleSizeChange(val: number): void {
    this.pageSize = val;
    this.getData();
  }
  // 当前页发生改变时
  private handleCurrentChange(val: number): void {
    this.pageNo = val;
    this.getData();
  }
}
